<div class="side-nav-container" [ngClass]="{active: sideNavActive}" appClickOutside
     (clickOutside)="clickOutSide()">
  <div class="side-nav">
    <div class="side-nav-header">
      <div class="user-profile-picture" *ngIf="customer?.pictureURL"
           [ngStyle]="{'background': 'url('+customer.pictureURL+') center center no-repeat'}">
      </div>
      <div class="user-profile-picture" *ngIf="!customer?.pictureURL">

      </div>
      <div class="user-full-name">
        {{customer?.displayName}}
      </div>
      <a [routerLink]="['/account/profile']" (click)="clickOutSide()" class="view-profile">
        {{'SIDENAV.VIEWPROFILE' | translate}}
      </a>
    </div>
    <div class="side-nav-menu">
      <ul class="menu-list">
        <li *ngFor="let item of menuItems" (click)="clickOutSide()">
          <a [routerLink]="[item.route]">
            <div class="menu-item-icon">
              <i [ngClass]="item.icon"></i>
            </div>
            <div class="menu-item-name">
              {{"SIDENAV.MENU." + item.translate | translate}}
            </div>
          </a>
        </li>
        <li>
          <a href="https://wahii.com/faq.html" target="_blank">
            <div class="menu-item-icon">
              <i class="wahii-icon-help"></i>
            </div>
            <div class="menu-item-name">
              {{"SIDENAV.MENU.HELP" | translate}}
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="side-nav-footer">
      <div class="logout-btn" (click)="signOut()">
        <i class="wahii-icon-logout"></i>
        {{'SIDENAV.LOGOUT' | translate}}
      </div>
      <div class="work-wahii">
        <a href="https://wahii.com/Distributor.html" target="_blank">
          {{'SIDENAV.WORK' | translate}}
        </a>
      </div>
    </div>
  </div>
</div>
